<template>
    <div>
        <button type="button" @click="editor.chain().focus().toggleBold().run()">
            Bold
        </button>
        <editor-content :editor="editor" />
    </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';

export default {
    components: {
        EditorContent,
    },

    props: {
        value: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            editor: null,
        };
    },

    watch: {
        value(value) {
            const isSame = this.editor.getHTML() === value;
            if (isSame) {
                return;
            }
            this.editor.commands.setContent(value, false);
        },
    },

    mounted() {
        let extensions = [
            StarterKit.configure({
                bold: {
                    HTMLAttributes: {
                        class: 'my-custom-class',
                    },
                },
            }),
        ];
        if (this.placeholder) {
            extensions.push(Placeholder.configure({
                placeholder: this.placeholder,
                emptyNodeClass: 'opacity-100 text-gray-400',
            }));
        }

        this.editor = new Editor({
            content: this.value,
            extensions: extensions,
            onUpdate: () => {
                this.$emit('input', this.editor.getHTML());
            },
            editorProps: {
                attributes: {
                    class: 'form-control h-auto prose max-w-none',
                },
            },
        });
    },

    beforeDestroy() {
        this.editor.destroy();
    },
};
</script>
